<template>
  <div class="modal-root flex-row justify-content-center" @click="$emit('close')">
    <slot></slot>
  </div>
</template>

<script>

export default {
  components: {
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  destroyed() {
    document.body.style.removeProperty('overflow');
  },
}
</script>

<style lang="scss">

.modal-root {
  z-index: 1;
  position: fixed;

  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  background: #000d;
}

</style>
